import { DateTime } from "@dashboard/components/Date";
import { Pill } from "@dashboard/components/Pill";
import { OrderDetailsFragment } from "@dashboard/graphql";
import { orderStatusMessages } from "@dashboard/intl";
import { transformOrderStatus } from "@dashboard/misc";
import { isReceivedManuallyMarked } from "@dashboard/orders/components/OrderProgressStepper/utils";
import { StatusType } from "@dashboard/types";
import { makeStyles } from "@saleor/macaw-ui";
import { Box, Skeleton, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

interface TitleProps {
  order?: OrderDetailsFragment;
}

const useStyles = makeStyles(
  theme => ({
    container: {
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      columnGap: theme.spacing(2),
      rowGap: theme.spacing(0.5),
    },
    statusContainer: {
      marginLeft: theme.spacing(2),
    },
  }),
  { name: "OrderDetailsTitle" },
);
const Title = (props: TitleProps) => {
  const intl = useIntl();
  const classes = useStyles(props);
  const { order } = props;

  if (!order) {
    return null;
  }

  // Once staff confirm receipt (the manual "received" mark), the order is truly
  // complete — show a terminal "Completed" pill instead of the native "Shipped".
  const { localized, status } = isReceivedManuallyMarked(order)
    ? {
        localized: intl.formatMessage(orderStatusMessages.completed),
        status: StatusType.SUCCESS,
      }
    : transformOrderStatus(order.status, intl);

  return (
    <div className={classes.container}>
      <Box display="flex" alignItems="center" flexWrap="nowrap" __whiteSpace="nowrap">
        {intl.formatMessage(
          { id: "AqXzM2", defaultMessage: "Order #{orderNumber}" },
          { orderNumber: order?.number },
        )}
        <div className={classes.statusContainer}>
          <Pill data-test-id="status-info" label={localized} color={status} />
        </div>
      </Box>

      <div>
        {order && order.created ? (
          <Text size={3} fontWeight="regular">
            <DateTime date={order.created} plain />
          </Text>
        ) : (
          <Skeleton style={{ width: "10em" }} />
        )}
      </div>
    </div>
  );
};

export default Title;
